import React from "react"
import styled from "@emotion/styled"
import { TransitionGroup, CSSTransition } from "react-transition-group"

const Message = styled.p`
    font-weight: 700;
    text-align: center;
    font-family: 'Ubuntu Condensed', sans-serif;
    font-size: 1.5rem;
`

const Cotizacion = styled.div`
    text-align: center;
    padding: .5rem;
    background-color: #c63637;
    border-radius: 0.375rem;
    margin-top: 1rem;
    position: relative;
`

const Resultado = ({cotizacion}) => {
    return (
        (cotizacion === 0 
            ? null 
            : (
                <Cotizacion>
                    <TransitionGroup
                        component="span"
                        className="resultado"
                    >
                        <CSSTransition
                            classNames="resultado"
                            key={cotizacion}
                            timeout={{enter: 500, exit: 500}}
                        >
                            <Message>El total es $ <span> {cotizacion} </span> </Message>
                        </CSSTransition>
                    </TransitionGroup>
                </Cotizacion>
            )
        )   
    )
}

export default Resultado